import AnalyticsEvents_V2, { GenericEvents } from '~/analytics/analyticsGA4'
import { PortalProducts } from '~/analytics/types/analytics.type'

export enum NotificationEvents {
  BELL_CLICK = 'bell_click',
  SHOW_MORE = 'show_more',
  CLOSE = 'close',
}

class NotificationAnalytics extends AnalyticsEvents_V2 {
  public constructor() {
    super(PortalProducts.NOTIFICATION)
  }
  public logNotificationClick(type: string, value?: Record<string, string | number | boolean>): void {
    const valueKey = value ? Object.keys(value)[0] : undefined
    const data = value ? Object.values(value)[0] : undefined
    if (valueKey && typeof data !== 'undefined') {
      this.logEvent({
        event: GenericEvents.BUTTON_CLICK,
        type,
        [valueKey]: data,
      })
    } else {
      this.logEvent({
        event: GenericEvents.BUTTON_CLICK,
        type,
      })
    }
  }
  public logBellClick(unread_notifications: number): void {
    this.logEvent({
      event: GenericEvents.BUTTON_CLICK,
      type: NotificationEvents.BELL_CLICK,
      unread_notifications,
    })
  }
  public logClick(type: NotificationEvents): void {
    this.logEvent({
      event: GenericEvents.BUTTON_CLICK,
      type,
    })
  }
}

export default new NotificationAnalytics()
